export default __webpack_public_path__ + "static/media/erp-1.9feaa283.png";